// extracted by mini-css-extract-plugin
export default {"root":"_2F5ux","label":"_3oSA9"};